<template>
  <div>
    <PageTitle
      title="Stock Transfers"
      :createRoute="'/stock-transfer/add'"
      :permission="'Transfer Create'"
    />
    <v-container
      fluid
      class="lighten-12 content pa-2"
      style="background-color: white"
    >
      <v-col cols="12" md="12" class="pa-3">
        <v-card class>
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in items" :key="item.tab">
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.tab">
              <v-form v-if="item.tab == 'Warehouse to Shop'">
                <v-row class="justify-end mr-5">
                  <v-btn
                    depressed
                    small
                    class="text-white btn_blue btn_medium w-100 mt-5"
                    @click="$router.push(`/stock-transfer/add`)"
                    >Create</v-btn
                  >
                </v-row>
              </v-form>
              <WarehousetoShopsTransferList
                v-if="item.tab == 'Warehouse to Shop'"
              />
              <ShoptoShopTransferList v-if="item.tab == 'Shop to Shop'" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>

      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/shared/PageTitle';
import TableFilters from '@/components/base/TableFilters';
import WarehousetoShopsTransferList from './WarehousetoShopsTransferList.vue';
import ShoptoShopTransferList from './ShoptoShopTransferList.vue';

export default {
  data: () => ({
    tab: 'Shop Products',
    items: [
      {
        tab: 'Warehouse to Shop',
        content: 'this is credit tab',
      },
      {
        tab: 'Shop to Shop',
        content: 'this is credit tab',
      },
    ],
  }),
  components: {
    PageTitle,
    TableFilters,
    WarehousetoShopsTransferList,
    ShoptoShopTransferList,
  },
};
</script>
